
import { computed, defineComponent, nextTick, onMounted, onUnmounted, ref, Ref, watch } from 'vue'
import AppHeader from '@/components/Header.vue'
import NetworkPoints from '@/components/network-point/List.vue'
import appHost, { isXagarApp } from '@/utils/app'
import { Popup, Search, Toast } from 'vant'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { getMapByGaode } from '@/utils/maptalkFactory'
import { usePlatformInfo } from '@/compositions/common'
import { wgs84ToGcj02, gcj02ToWgs84 } from '@/utils/geo'
import { useLocactionInfo } from '@/compositions/common'
import { VectorLayer, Marker, Coordinate } from 'maptalks'
import { UserLocationInfoStorage } from '@/storage/common'
import { parseNetworkPointtItem } from '@/utils/dataFactory'
import getMapSiteInfo from '@/compositions/map/index'
import PointDetailOpenStatus from '@/compositions/network-point/pointDetail'
import { GetNetworkpoints } from '@/apis/fault'
import normalNetworkQrcode from '@/assets/service/page-networks-qrcode.png'
import networkCarQrcode from '@/assets/service/page-networks-qrcode-car.png'

export default defineComponent({
  name: 'Networkpoint-Index',
  components: {
    AppHeader,
    NetworkPoints,
    VanPopup: Popup,
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const device_type = route.query.device_type as string

    const qrcodeUrl = computed(() => {
      return isXagarApp ? networkCarQrcode : normalNetworkQrcode
    })
    const navHeight = 44
    const points = ref([])
    const isNoSearching = ref(true)
    const { isSrc4Device, isTableDevice } = usePlatformInfo()
    const { pointDetailOpen, setPointDetailOpen } = PointDetailOpenStatus()
    const pHeight = ref('48%')
    const appStatusBarHeight = computed<number>(() => store.state.appStatusBarHeight)
    const mapbox = ref<HTMLElement>()
    const { initNearbyWarehouseHandle, locationInfo } = useLocactionInfo()
    let siteTimer: any = null
    const _query = {
      page: 0,
      per_page: 30,
    }
    const show = ref(true)
    let { mapZoom, mapCenter } = getMapSiteInfo()
    let layer: VectorLayer = null
    const map = ref(null)
    let _startY = 0
    const popupCloseabled = computed(() => {
      return ['networkpoint-detail'].includes(route.name as string)
    })
    const guid = computed(() => {
      return route.params?.guid || ''
    })
    const activedPoint = computed(() => {
      return points.value.find((it) => it.guid === guid.value)
    })
    const initPopup = () => {
      if (popupCloseabled.value) {
        if (pointDetailOpen.value) {
          pHeight.value = `calc(100% - ${appStatusBarHeight.value + navHeight}px)`
        } else {
          pHeight.value = '48%'
        }
      } else {
        pHeight.value = '48%'
        if (route.name === 'networkpoint-list') {
          setPointDetailOpen()
        }
      }
    }
    watch(guid, () => {
      initPopup()
    })
    watch(activedPoint, (newv, oldv) => {
      if (oldv) {
        Object.assign(oldv, {
          drawSrc: oldv.iconSrc,
          w: 40,
          h: 40,
          markerDy: 0,
        })
        drawSiteBefore(oldv)
      }
      if (newv) {
        Object.assign(newv, {
          drawSrc: newv.activedIconSrc,
          w: 60,
          h: 60,
          markerDy: -24,
        })
        drawSiteBefore(newv)
      }
    })

    initPopup()
    const touchStart = (e: TouchEvent) => {
      if (e.touches.length == 1 && popupCloseabled.value) {
        //tounches类数组，等于1时表示此时有只有一只手指在触摸屏幕
        _startY = e.touches[0].clientY // 记录开始位置
      }
    }
    const touchEnd = (e: TouchEvent) => {
      if (e.changedTouches.length == 1 && popupCloseabled.value) {
        let endY = e.changedTouches[0].clientY
        const disY = endY - _startY
        if (disY < -50) {
          pHeight.value = `calc(100% - ${appStatusBarHeight.value + navHeight}px)`
          setPointDetailOpen(true)
        }
        if (disY > 50) {
          pHeight.value = '48%'
          setPointDetailOpen()
        }
      }
    }
    const onSearchFocus = () => {
      if (!popupCloseabled.value) {
        isNoSearching.value = false
        // pHeight.value = `calc(100% - ${appStatusBarHeight.value + navHeight}px)`
      }
    }

    const onSearchBlur = (val: string) => {
      if (!popupCloseabled.value) {
        if (val === '') {
          // pHeight.value = '48%'
          isNoSearching.value = true
        } else {
          isNoSearching.value = false
          // pHeight.value = `calc(100% - ${appStatusBarHeight.value + navHeight}px)`
        }
      }
    }
    // const onChangeKeywords = (val: string) => {
    //   if (!popupCloseabled.value) {
    //     if (val === '') {
    //       pHeight.value = '48%'
    //     } else {
    //       pHeight.value = `calc(100% - ${appStatusBarHeight.value + navHeight}px)`
    //     }
    //   }
    // }
    const onSetCenter = (point: number[]) => {
      console.log(
        'point',
        point.map((val) => Number(val.toFixed(4))),
        new Coordinate(wgs84ToGcj02Func(point))
      )
      map.value.setCenter(new Coordinate(wgs84ToGcj02Func(point)))
    }
    const onLeftClick = (): void => {
      if (popupCloseabled.value) {
        router.go(-1)
      } else {
        appHost.goAppBack()
      }
    }
    const getItems = async (center?: number[]): Promise<void> => {
      _query.page++
      try {
        const centers = center || []
        const [lng, lat] = [
          centers[0] || locationInfo.value?.lng || 0,
          centers[1] || locationInfo.value?.lat || 0,
        ]
        const obj = {
          keywords: '',
          lng: Number(lng),
          lat: Number(lat),
          ..._query,
          device_type,
        }
        const ps = [obj.lng, obj.lat]
        const result: any = await GetNetworkpoints(obj)
        const list = result.data
        if (list?.length) {
          const arr = list.map((it: any) => it.guid)
          list.forEach((it: any) => {
            parseNetworkPointtItem(it)
            if (it.guid === guid.value) {
              it.drawSrc = it.activedIconSrc
              it.w = 60
              it.h = 60
              it.markerDy = -24
            } else {
              it.drawSrc = it.iconSrc
              it.w = 40
              it.h = 40
              it.markerDy = 0
            }
            drawSiteBefore(it)
          })
          points.value = points.value.length ? points.value.concat(list) : list
          if (list.length >= _query.per_page) {
            getItems(ps)
          }
        }
      } catch (err: any) {
        _query.page--
        const message: string = err.message
        Toast(message)
        console.error(message)
      }
    }

    const clearTimer = () => {
      if (siteTimer) {
        clearTimeout(siteTimer)
      }
    }

    const createLayer = () => {
      if (!layer && map.value) {
        layer = new VectorLayer(Date.now().toString()).addTo(map.value)
      }
    }
    const drawSiteBefore = (it: any) => {
      clearMarker(it.id)
      drawSite(it, it.drawSrc)
    }
    const clearMarker = (id: string) => {
      if (!layer || !map.value || !id) return
      const m = layer.getGeometryById(id)
      if (m) {
        layer.removeGeometry(m)
      }
    }
    const relocationSite = async (isLocation = false) => {
      try {
        await initNearbyWarehouseHandle()
        // 刷新了经纬度信息
        const id = 'me'
        clearMarker(id)
        const point = [
          parseFloat(locationInfo.value?.lng?.toString()),
          parseFloat(locationInfo.value?.lat?.toString()),
        ]
        const item = {
          id,
          name: '我',
          point,
          w: 30,
          h: 30,
          markerDy: 0,
        }
        drawSite(item, '/images/poi_icon_position_user_direction.png')
        if (isLocation) {
          map.value.setCenter(new Coordinate(wgs84ToGcj02Func(point)))
        }
      } catch (error) {
        console.log('error', error)
      }
      // clearTimer()
      // siteTimer = setTimeout(() => {
      //   relocationSite()
      // }, 5000)
    }
    const drawSite = (item: any, src: string, isNeedName = false): void => {
      if (!layer || !map.value || !src || !item.point) return
      const symbol = {
        markerFile: src,
        markerWidth: item.w,
        markerHeight: item.h,
        markerDy: item.markerDy || 0,
        markerVerticalAlignment: 'middle',
        scale: 1,
      }
      if (isNeedName) {
        Object.assign(symbol, {
          textName: item.name || '未命名',
          textFill: 'rgba(255,255,255,1)',
          textSize: 12,
          textWeight: 500,
        })
      }
      const marker: Marker = new Marker(wgs84ToGcj02Func(item.point), {
        id: item.id || Date.now().toString(),
        editable: false,
        symbol,
      })
      if (item.id !== 'me') {
        marker.on('click', (e) => {
          clickItem(item)
        })
      }
      layer.addGeometry(marker)
    }
    const clickItem = (item: any) => {
      if (item?.guid === guid.value) return
      const obj = {
        name: 'networkpoint-detail',
        params: {
          guid: item.id,
        },
        query: {
          type: item.type,
        },
      }
      if (popupCloseabled.value) {
        router.replace(obj)
      } else {
        router.push(obj)
      }
    }
    const wgs84ToGcj02Func = (point: number[]) => {
      const [lng, lat] = point
      const center = wgs84ToGcj02({ lat, lng })
      return [center.lng, center.lat]
    }
    const gcj02ToWgs84Func = (point: number[]) => {
      const [lng, lat] = point
      const center = gcj02ToWgs84({ lat, lng })
      return [center.lng, center.lat]
    }
    const ensureGetItems = () => {
      setTimeout(() => {
        if (!map.value || !(locationInfo.value?.lat && locationInfo.value?.lng)) {
          ensureGetItems()
          return
        }
        getItems()
      }, 3000)
    }

    function initPageHandle() {
      map.value = getMapByGaode(mapbox.value, {
        center: wgs84ToGcj02Func(mapCenter.value),
        zoom: mapZoom.value,
        attribution: false,
      }).on('viewchange', () => {
        const mapView = map.value.getView()
        const { center, zoom } = mapView as { center: number[]; zoom: number }
        store.commit('setMapSite', {
          center: gcj02ToWgs84Func(center),
          zoom,
        })
      })
      createLayer()
      relocationSite(true)
      ensureGetItems()
    }
    watch(
      () => locationInfo.value,
      () => {
        if (!map.value && locationInfo.value?.lat && locationInfo.value?.lng) {
          UserLocationInfoStorage.set(locationInfo.value)
          nextTick(() => {
            initPageHandle()
          })
        }
      }
    )
    onUnmounted(() => {
      clearTimer()
    })

    onMounted(async () => {
      if (isSrc4Device.value) {
        return
      }
      try {
        await initNearbyWarehouseHandle()
        // 成功获取后，hooks里会给locationInfo赋值
        console.log('loca', locationInfo.value)
      } catch (error) {
        console.log('error', error)
      }
      // if (hasAuthorized.value) {
      //   initPageHandle()
      // } else {
      //   // 获取相关授权后，获取定位信息
      // }
    })

    return {
      isNoSearching,
      onSearchFocus,
      onSearchBlur,
      show,
      onSetCenter,
      relocationSite,
      pHeight,
      touchStart,
      touchEnd,
      popupCloseabled,
      onLeftClick,
      map,
      mapbox,
      isSrc4Device,
      locationInfo,
      qrcodeUrl,
      isTableDevice,
    }
  },
})
